import React, { useContext, useEffect } from 'react';
import SEOPageTitle from 'components/shared/SEOPageTitle';
import AdminSubscriptionsList from 'components/client-payment/AdminSubscriptionsList';
import AppBarContext from 'context/AppBarContext';

/**
 * Página admin "Suscriptores" (en el dropdown de Pagos del sidebar). Solo monta el título
 * del AppBar y renderiza el listado de suscriptores (tabla + filtros).
 */
function AdminSubscriptionsPage() {
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);

  useEffect(() => {
    setAppBarTitle('Suscriptores');
    setAppBarButton(null);
  }, [setAppBarButton, setAppBarTitle]);

  return (
    <>
      <SEOPageTitle title="Suscriptores" />
      <AdminSubscriptionsList />
    </>
  );
}

export default AdminSubscriptionsPage;
